export type PostalRecipientFormValue = {
  recipientName: string
  country: string
  street: string
  house_number: string
  zip: string
  city: string
  address_extra?: string
}

export const postalRecipientValidation = (value: PostalRecipientFormValue) =>
  [
    value.recipientName,
    value.country,
    value.street,
    value.house_number,
    value.zip,
    value.city,
  ].every((part) => part.trim())
    ? null
    : "Bitte Name und vollständige Zieladresse angeben."
